import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { Divider } from "@mui/material";
import { BiSearch } from "react-icons/bi";
import { handleClickOutsideCloseDropdown } from "../../pages/utils/utils";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const InputSearch = forwardRef(
  (
    {
      dropdownOptions = [],
      onSearch,
      placeholder = "Search",
      defaultSearchAttribute = "",
      defaultSearchValue = "",
      customStyles = {},
      debounceDelay = 500, // Delay in ms for debounce
    },
    ref
  ) => {
    const [inputValue, setInputValue] = useState(defaultSearchValue);
    const [attributeName, setAttributeName] = useState(defaultSearchAttribute);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const dropdownRef = useRef(null);

    // Expose clearInput function to parent via ref
    useImperativeHandle(ref, () => ({
      clearInput: () => setInputValue(""),
    }));

    const handleDropdownChange = (value) => {
      setAttributeName(value);
      setInputValue("");
      setIsDropdownOpen(false);
    };

    const handleDropdownToggle = () => {
      if (dropdownOptions?.length > 1) {
        setIsDropdownOpen(!isDropdownOpen);
      }
    };

    const handleSearchInput = (val) => {
      setInputValue(val);
    };

    const handleSubmit = () => {
      if (onSearch) {
        onSearch(attributeName, inputValue);
      }
    };

    useEffect(() => {
      if (initialLoad) {
        setInitialLoad(false);
        return;
      }

      const timer = setTimeout(() => {
        handleSubmit();
      }, debounceDelay);

      return () => clearTimeout(timer);
    }, [inputValue, attributeName, debounceDelay]);

    useEffect(() => {
      const clickHandler = (event) =>
        handleClickOutsideCloseDropdown(event, dropdownRef, setIsDropdownOpen);

      document.addEventListener("click", clickHandler);
      return () => {
        document.removeEventListener("click", clickHandler);
      };
    }, []);

    return (
      <div
        className="btn-group"
        style={{
          borderRadius: "8px",
          height: "42px",
          width: "100%",
          border: "1px solid #DCDCDE",
          ...customStyles.container,
        }}
        ref={dropdownRef}
      >
        <div style={{ marginTop: "8px", marginLeft: "8px" }}>
          <div
            className="dropdown"
            style={{
              display: "inline-block",
              position: "relative",
              cursor: "pointer",
              minWidth: "100px",
              ...customStyles.dropdown,
            }}
          >
            <div className="d-flex align-items-center" onClick={handleDropdownToggle}>
              <p
                className="m-0"
                style={{
                  cursor: "pointer",
                  paddingLeft: "10px",
                  color: "var(--text-high, rgba(1, 1, 2, 0.72))",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  fontWeight: 600,
                  minWidth: "200px",
                  ...customStyles.dropdownToggle,
                }}
              >
                {dropdownOptions.find((option) => option.value === attributeName)?.label || "Select"}
              </p>

              {dropdownOptions?.length > 1 && <ArrowDropDownIcon />}
            </div>
            {isDropdownOpen && (
              <div
                className="dropdown-menu"
                style={{
                  display: "block",
                  marginTop: "12px",
                  width: "200px",
                  marginLeft: "-12px",
                  ...customStyles.dropdownMenu,
                }}
              >
                {dropdownOptions.map((option) => (
                  <div
                    key={option.value}
                    className="dropdown-item dropdownContentStyling"
                    onClick={() => handleDropdownChange(option.value)}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      ...customStyles.dropdownItem,
                    }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <span
          style={{
            marginBottom: "10px",
            marginTop: "10px",
            marginLeft: "10px",
            ...customStyles.divider,
          }}
        >
          <Divider orientation="vertical" color="#C2C2C2" />
        </span>
        <BiSearch
          style={{
            marginTop: "7px",
            height: "28px",
            width: "28px",
            color: "#C2C2C2",
            marginRight: "12px",
            marginLeft: "8px",
            ...customStyles.icon,
          }}
        />
        <input
          type="text"
          value={inputValue}
          onChange={(e) => handleSearchInput(e.target.value)}
          style={{
            border: "none",
            borderRadius: "8px",
            outline: "none",
            marginLeft: "-4px",
            fontSize: "14px",
            width: "inherit",
            ...customStyles.input,
          }}
          placeholder={placeholder}
        />
      </div>
    );
  }
);

export default InputSearch;
